<template>
    <v-card>
        <v-card-title>
            {{$t('merchant.add')}}
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="$router.push({name: 'merchant-template', params: {isTemplate: 1}})">
                Excel Template
                <v-icon right>mdi-download</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <!-- <v-row>
                    <v-select
                        outlined
                        label="Username"
                        v-model="usernameCol"
                        :items="usernameCol_items"></v-select>
                </v-row>
                <v-row>
                    <v-select
                        outlined
                        label="Password"
                        v-model="passwordCol"
                        :items="passwordCol_items"></v-select>
                </v-row> -->
                <v-row>
                    <v-file-input
                        outlined
                        prepend-icon=""
                        prepend-inner-icon="$file"
                        accept=".xlsx, .xls, .csv"
                        label="Import File"
                        placeholder="Select..."
                        @change="uploadExcel"></v-file-input>
                </v-row>
                <v-row>
                    <v-chip
                        label
                        small
                        @click="addMerchant">
                        <v-icon>mdi-account-plus</v-icon>
                    </v-chip>
                    <v-chip
                        label
                        small
                        @click="removeMerchant">
                        <v-icon>mdi-account-minus</v-icon>
                    </v-chip>
                </v-row>
                <v-row>
                    <canvas-datagrid
                        :data.prop="excelData"
                        @rendercell="loadDataCheck"
                        @beforesortcolumn="beforeSortColumn"
                        style="height: 300px"
                        id="excelGrid"></canvas-datagrid>
                </v-row>
                <v-row>
                    <br>
                </v-row>
                <v-row>
                    <v-btn color="primary" @click="importCheck">
                        {{$t('merchant.create')}}
                    </v-btn>
                </v-row>
            </v-container>
        
        </v-card-text>
            
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-dialog v-model="dialog" scrollable max-width="640px">
            <v-card>
                <v-card-text style="height: 360px; padding: 15px" v-html="dialogMsg">
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <RouterView></RouterView>
    </v-card>
</template>

<script>
    import {computed, ref, onMounted} from '@vue/composition-api';
    
    import XLSX from 'xlsx';
    import CanvasDatagrid from 'canvas-datagrid';
    import {useGet} from "feathers-vuex";
    import _ from 'lodash';
    import eConfig from "../../evention-config.js"

    export default {
        name: 'EventMerchantBatchAdd',
        setup(props, {root}) {
            const {Merchant} = root.$FeathersVuex.api;
            
            onMounted(() => {
                document.getElementById('excelGrid').style.width = '100%';
                document.getElementById('excelGrid').controlInput.onblur = () => {
                    if (document.getElementById('excelGrid') && document.getElementById('excelGrid').input) {
                        document.getElementById('excelGrid').input.onblur = () => {
                            document.getElementById('excelGrid').endEdit(false);
                        }
                    }
                };
            });

            const eventId = computed(() => root.$route.params.eventId);
            
            const overlay = ref(false);
            
            const dialog = ref(false);
            const dialogMsg = ref('');
            
            const dbColMapping = eConfig.merchant.dbColMapping;
            
            const colOptions = ref(Object.keys(dbColMapping).map((col) => {return {text: col, value: col}}));
            
            const readXLSX = (file) => {
                let nameSplit = file.name.split('.');
                let format = nameSplit[nameSplit.length - 1];
                if (!['xls', 'xlsx', 'csv'].includes(format)) {
                    return false;
                }
                return new Promise((resolve) => {
                    let reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = function (evt) {
                        let data = evt.target.result;
                        var workbook = XLSX.read(data, {type: 'binary'});
                        let outdata = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {defval: ''});
                        resolve(outdata);
                    }
                });
            }

            const uploadExcel = async (f) => {
                if (f) {
                    const outdata = await readXLSX(f);
                    excelData.value = outdata;
                } else {
                    excelData.value = JSON.parse(JSON.stringify(excelData_init));
                    // usernameCol.value = 'Username';
                    // passwordCol.value = '';
                }
                
                if (excelData.value && excelData.value.length >= 1) {
                    colOptions.value = Object.keys(excelData.value[0]).map((col) => {return {text: col, value: col}});
                }
                return false;
            };
            
            const checkValue = (header, value) => {
                if (header == 'Username' && !/^[^\s]+(?: [^\s]+)*$/.test(value)) { // no trailing spaces and extra spaces
                    return false;
                }
                // if (header == 'Password' && !/^[^\s]+(?: [^\s]+)*$/.test(value)) { // no trailing spaces and extra spaces
                //     return false;
                // }
                if (header == 'First Name' && value.toString().trim() == '') {
                    return false;
                }
                if (header == 'Email' && value !== 'Email' && !/^[^@]+@[^@]+\.[^@]+$/.test(value)) {
                    return false;
                }
                return true;
            };
            
            const loadDataCheck = (e) => {
                if (!_.isEqual(excelData.value, excelData_init)) {
                    if (!checkValue(e.cell.header.name, e.cell.value)) {
                        e.ctx.fillStyle = '#FFAAAA';
                    }
                }
            };
            
            const importCheck = async () => {
                // if (!usernameCol.value) {
                //     root.$store.dispatch('showSnackBar', 'Please select column for username');
                //     return false;
                // }
                
                if (!excelData.value[0].hasOwnProperty('First Name') || !excelData.value[0].hasOwnProperty('Username')) {
                    root.$store.dispatch('showSnackBar', 'Invalid Merchant List Format');
                    return false;
                }
                
                for (let y = 0; y < excelData.value.length; y++) {
                    let rowValid = Object.keys(excelData.value[y]).every((header) => { return checkValue(header, excelData.value[y][header]); });
                    if (!rowValid) {
                        root.$store.dispatch('showSnackBar', 'Row #' + (y + 1) + ' is not valid');
                        return;
                    }
                }
                
                let duplicatesUsername = _.difference(excelData.value, _.uniqBy(excelData.value, 'Username'), 'Username');
                if (duplicatesUsername.length >= 1) {
                    root.$store.dispatch('showSnackBar', 'Duplicate Username: ' + duplicatesUsername[0]['Username']);
                    return false;
                }
                
                // let duplicatesQrcode = _.difference(excelData.value, _.uniqBy(excelData.value, 'Qrcode'), 'Qrcode');
                // if (duplicatesQrcode.filter((row) => (row.Qrcode !== '')).length >= 1) {
                //     root.$store.dispatch('showSnackBar', 'Duplicate QR Code: ' + duplicatesQrcode[0]['Qrcode']);
                //     return false;
                // }
                
                overlay.value = true;
                
                let count = 0;
                let errorCount = 0;
                let errorMsg = '';
                
                for (let g of excelData.value) {
                    // post process data
                    if (g.hasOwnProperty('Username') && g['Username']) g['Username'] = g['Username'].toString().trim();
                    if (g.hasOwnProperty('Email') && g['Email']) g['Email'] = g['Email'].toLowerCase().trim();
                    // if (g.hasOwnProperty('Qrcode') && g['Qrcode'] === '') g['Qrcode'] = (Date.now().toString(36) + Math.random().toString(36).substr(2,3));
                    // if (g.hasOwnProperty('Local/Oversea(local/oversea)') && g['Local/Oversea(local/oversea)'] === '') g['Local/Oversea(local/oversea)'] = 'local'; // default to 'local' if omitted
                    // if (g.hasOwnProperty('Private account(yes/no)') && g['Private account(yes/no)'] === '') g['Private account(yes/no)'] = 'yes'; // default to 'yes' if omitted
                    // if (g.hasOwnProperty('Notification(yes/no)') && g['Notification(yes/no)'] === '') g['Notification(yes/no)'] = 'yes'; // default to 'yes' if omitted
                    // if (g.hasOwnProperty('Local/Oversea(local/oversea)')) g['Local/Oversea(local/oversea)'] = g['Local/Oversea(local/oversea)'].toLowerCase().trim(); // trim whitespaces
                    // if (g.hasOwnProperty('Private account(yes/no)')) g['Private account(yes/no)'] = g['Private account(yes/no)'].toLowerCase().trim(); // trim whitespaces
                    // if (g.hasOwnProperty('Notification(yes/no)')) g['Notification(yes/no)'] = g['Notification(yes/no)'].toLowerCase().trim(); // trim whitespaces
                    
                    let $_EventGuest = new Merchant();
                    $_EventGuest.eventId = eventId.value;
                    $_EventGuest.username = g['Username'];
                    $_EventGuest.password = g['Password'];
                    $_EventGuest.firstname = g['First Name'];
                    $_EventGuest.lastname = g['Last Name'];
                    $_EventGuest.email = g['Email'];
                    $_EventGuest.mobile = g['Mobile'];
                    $_EventGuest.remarks = g['Remarks'];
                    
                    // let metadata = {...g};
                    // // prepare standard fields & extra fields (i.e. metadata)
                    // for (let colTitle in dbColMapping) {
                    //     if (g.hasOwnProperty(colTitle)) {
                    //         delete metadata[colTitle];
                    //         $_EventGuest[dbColMapping[colTitle]] = g[colTitle];
                    //     } else {
                    //         $_EventGuest[dbColMapping[colTitle]] = '';
                    //     }
                    // }
                    // $_EventGuest.metadata = JSON.stringify(metadata);
                    
                    let temp = await $_EventGuest.save().then(() => {
                        return false;
                    }, (e) => {
                        // root.$handleFeatherError(e);
                        return e.errors ? e.errors.map ? (e.errors.map(a => a.message)).join('; ') : e.message : e.statusText;
                    });
                    count++;
                    if (temp) {
                        errorMsg += '<li>Row #' + count + ' - ' + temp + '</li>';
                        errorCount++;
                    }
                }
                
                overlay.value = false;
                if (errorCount) {
                    dialogMsg.value = (count - errorCount) + ' of ' + count + ' Merchant(s) sucessfully created.<br><br>' + (errorCount) + ' of ' + count + ' Merchant(s) NOT created:<br><ul>' + errorMsg + '</ul>';
                    dialog.value = true;
                } else {
                    dialogMsg.value = '';
                    root.$store.dispatch('showSnackBar', 'Success. ' + count + ' Merchant(s) Created.' + errorMsg);
                    root.$router.replace({name: 'event-merchants'});
                }
            };
            
            // const usernameCol = ref('Username');
            // const usernameCol_items = computed(() => [
            //     ...colOptions.value
            // ]);
            
            // const passwordCol = ref('');
            // const passwordCol_items = computed(() => [
            //     {text: '(no password)', value: ''},
            //     ...colOptions.value
            // ]);
            
            const excelData_init = [{
                ...Object.keys(dbColMapping).reduce((reduced, key) => ({ ...reduced, [key]: '' }), {})
            }];
            const excelData = ref(JSON.parse(JSON.stringify(excelData_init)));
            
            const beforeSortColumn = (e) => {
                e.preventDefault();
            };
            
            const addMerchant = () => {
                document.getElementById('excelGrid').addRow({});
            };
            
            const removeMerchant = () => {
                let rowSelected = document.getElementById('excelGrid').selectedRows.map((row, j) => !!row && j).filter(j => j !== false && j >= 0).reverse();
                if (rowSelected.length >= 1 && document.getElementById('excelGrid').selections.every(row => !row || !row.length || row.length === document.getElementById('excelGrid').columnOrder.length + 1)) {
                    if (excelData.value.length - rowSelected.length >= 1) {
                        rowSelected.forEach(j => document.getElementById('excelGrid').deleteRow(j));
                    } else {
                        excelData.value = JSON.parse(JSON.stringify(excelData_init));
                    }
                } else {
                    root.$store.dispatch('showSnackBar', 'Please select entire row(s) by clicking row number.');
                }
            };
            
            return {
                CanvasDatagrid,
                uploadExcel,
                excelData,
                importCheck,
                loadDataCheck,
                // passwordCol,
                // passwordCol_items,
                // usernameCol,
                // usernameCol_items,
                overlay,
                beforeSortColumn,
                addMerchant,
                removeMerchant,
                dialogMsg,
                dialog
            }
        },
    }
</script>